import { useState } from "react";
import { makeStyles, Typography, Select as MuiSelect, MenuItem } from "@material-ui/core";

import { Icon } from "./Icon";
import dropdownIcon from "../../assets/images/settings/dropdownicon.svg";
import { capitalize } from "../../services";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  rootSelect: {
    backgroundColor: "transparent",
  },
}));

export const Select = ({
  label,
  value,
  options,
  onChange,
  error,
  rootStyle,
  downArrow,
  optionNames = [],
  disabled,
  multiple = false,
  displayEmpty = false,
  multiplePlaceHolder,
  renderValueClass,
  placeholder,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      {label && <Typography color="textPrimary">{label}</Typography>}
      <MuiSelect
        displayEmpty={displayEmpty}
        disabled={disabled}
        error={error}
        classes={{ root: rootStyle || classes.rootSelect }}
        onChange={(event) => onChange(event.target.value)}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={value}
        multiple={multiple}
        {...(displayEmpty &&
          placeholder && {
            renderValue: (value) =>
              value?.length ? (
                value
              ) : (
                <Typography style={{ color: COLORS.darks[0][50], lineHeight: "inherit" }}>
                  {placeholder}
                </Typography>
              ),
          })}
        {...(downArrow && {
          IconComponent: () => (
            <Icon
              hoverable
              src={dropdownIcon}
              style={{ position: "absolute", right: "10px" }}
              onClick={() => setOpen(!open)}
            />
          ),
        })}
        {...(renderValueClass && {
          renderValue: (selected) => {
            if (!multiple) {
              if (typeof selected === "string" || selected instanceof String) {
                if (optionNames) {
                  const index = options.indexOf(selected);
                  if (index >= 0) {
                    return (
                      <Typography className={renderValueClass}>
                        {capitalize(optionNames[index])}
                      </Typography>
                    );
                  }
                }
                return <Typography className={renderValueClass}>{capitalize(selected)}</Typography>;
              }
              return (
                <Typography className={renderValueClass}>{capitalize(selected.name)}</Typography>
              );
            }

            if (selected.length === 0) {
              return <Typography className={renderValueClass}>{multiplePlaceHolder}</Typography>;
            }

            let sentence = selected
              .map((value) => {
                if (typeof value === "string" || value instanceof String) {
                  return capitalize(value);
                }
                return value.name;
              })
              .join(", ");

            if (sentence.length > 20)
              sentence = `${sentence.slice(0, 15)} ...`.replace(", .", " .");
            return <Typography className={renderValueClass}>{sentence}</Typography>;
          },
        })}
      >
        {multiple && (
          <MenuItem disabled value="">
            <Typography>{multiplePlaceHolder}</Typography>
          </MenuItem>
        )}
        {options.map((option, index) =>
          typeof option !== "object" ? (
            <MenuItem value={option} key={index}>
              {optionNames[index] || option}
            </MenuItem>
          ) : (
            <MenuItem value={option} key={option.id}>
              {option.name}
            </MenuItem>
          )
        )}
      </MuiSelect>
    </>
  );
};
